import {
  Box,
  Heading,
  Text,
  VStack,
  Stack,
  Highlight,
  Link,
  Button,
  useColorModeValue,
} from "@chakra-ui/react";
import { PhoneIcon, EmailIcon, ExternalLinkIcon } from "@chakra-ui/icons";
import Header from "../../../Navbar/Header";
import Footer from "../../../Navbar/Footer";

export const MootProposition = () => {
  return (
    <>
      <Header />
      <Box
        // bgGradient="linear(to-r, teal.100, blue.50)"
        py={5}
        px={{ base: 4, md: 12 }}
        // minH="100vh"
      >
        <VStack spacing={10} maxW="6xl" mx="auto" textAlign="justify">
          <Heading
            size="xl"
            bgGradient="linear(to-r, teal.500, blue.500)"
            bgClip="text"
          >
            MOOT PROPOSITION
          </Heading>

          <Box
            bg={useColorModeValue("white")}
            p={6}
            borderRadius="2xl"
            boxShadow="lg"
            w="100%"
          >
            <Stack spacing={8} marginLeft="50px" marginRight={"50px"}>
              <Text fontSize="lg">
                <strong>
                  The facts leading to the filing of the instant complaint are
                  as follows:
                </strong>
              </Text>

              <Text>
                That the Complainant, Raj Kundra, is a highly educated,
                law-abiding citizen of India and has full faith in the law
                administration system. The Complainant, by way of his endeavours
                and bona fide actions, has developed credibility and goodwill
                among his social circle. That the Complainant and the Accused,
                Shilpa Shetty, are husband and wife and got married on 15th
                February 2005. After the marriage, the Complainant and the
                Accused lived together and cohabited as husband and wife in
                their shared accommodation.
              </Text>

              <Text>
                That the Complainant is highly qualified, possessing a B.Tech in
                Mechanical Engineering, and is working as an Associate at
                MechForce India Pvt. Ltd., Gurugram, Haryana. He is a mechanical
                engineer with 20 years of experience in the Building Services
                Industry and possesses extensive experience in designing
                plumbing and firefighting services in real estate projects. The
                Complainant is also a reputed and certified trainer affiliated
                with the Institute of Engineers (India). The Complainant gave
                due care, love, and affection to the Accused with utmost
                devotion and always fulfilled her demands without any objection.
                The Complainant is currently employed at MechForce India Pvt.
                Ltd., Gurugram, Haryana, and has worked endlessly toward
                attaining his current post and reputation through his
                professional and personal efforts. He has maintained a
                satisfactory performance and character record and has never been
                summoned by the Human Resources Department for any internal
                issue or misconduct.
              </Text>

              <Text>
                That the wife of the Complainant, herein the Accused, Shilpa
                Shetty, through her email ID shilpashetty1211@gmail.com, wrote
                several derogatory and threatening emails to the Complainant and
                to his office email IDs, including that of the HR Department
                (hr@mechforce.in), tagging all the heads and directors of the
                company where the Complainant is currently employed. These
                emails were also sent to the Complainant’s previous employer,
                making malicious and false allegations against him. The Accused
                wrote an email on 17th March 2024, at around 11:32 AM, from her
                email ID shilpashetty1211@gmail.com to the Complainant's email
                ID raj.kundra@mechforce.in. The email was also received by the
                Complainant at his residence at H-72, Khanna Colony, Khanpur,
                Delhi-110062. At the time, the Complainant was working from home
                due to the lockdown, and the same email was also sent to the HR
                of the company. The email, which contained inflammatory and
                defamatory content, was sent to sangeetasingh@mechforce.in. The
                content of the said email, as reproduced for the perusal of this
                Hon’ble Court, is as follows:
              </Text>

              <Text>
                “I would like to bring your kind knowledge that I RAJ KUNDRA who
                is working in your company as in associate position. He is
                living apart from family from last six years. We have completed
                15 years of our arrange marriage and we have two issues with our
                wedlock and I am only person who is taking care of them from
                last six years as a single parent. Why I am writing this email
                to you because he is harassing me my kids mentally socially and
                financially. Neither he is following the court rules nor he is
                responding the mails. Reason behind this separation is his extra
                marital affairs with his colleagues. Not only this he has
                cheated his previous organization by doing their projects
                unofficially with the help of bribes.”
              </Text>

              <Text>
                I am his wife so he was taking all the money in my accounts. On
                the ground of bribe and his malafide intentions his previous
                companies has fired him by asking his resignation forcefully.
                Where he and his family members on bail under two criminal
                cases. He is not abiding the court order honestly so I am bound
                to inform you all because of his this kind of behavior effecting
                my kid’s day to day life and their future.
              </Text>

              <Text>
                …. She further wrote in the same email. If I talk on humanity
                grounds than its really strange to understand that a person who
                is not capable to keep his kids happy or can’t pay for their
                expenses then how can he will be a loyal person to his company.
                A person who can’t manage his own family image socially than how
                can a company thinks he will be able to handle their image in
                the market.
                <br />
                <br />
                For us he is pain in neck for me n my kids with because he is
                cold fish. I will be so much thankful if you will be able to do
                needful for my two small kids.”
              </Text>
              <Text>
                That the said email dated 17.03.2024 was sent to the
                Complainant’s and his HR’s email addresses, with the subject
                line “[EXTERNAL] Payment request and awareness letter”. The
                email included serious allegations of bribery and
                misappropriation of funds, alleging that the Accused received
                money in her bank accounts from the Complainant's alleged
                corrupt dealings.
                <br />
                <br />
                The Accused also stated in the same email that:
                <br />
                <br />
                “on the grounds of bribery and his malafide intentions his
                previous companies has fired him by asking resignation
                forcefully.”
                <br />
                <br />
                It is pertinent to note that such serious allegations of bribery
                and misconduct were made against the Complainant without any
                concrete evidence.
                <br />
                <br />
                The contents of the email dated 17.03.2024 are defamatory and
                malicious in nature, and directly targeted to tarnish the image
                of the Complainant. The Complainant, a professional in his field
                with 20 years of experience, has earned his reputation through
                years of hard work.
                <br />
                <br />
                The facts as alleged by the Accused in the said emails are
                utterly false and intended to harm the standing and character of
                the Complainant. The Petitioner is filing copies of the emails
                along with the certificate under Section 65B of the Indian
                Evidence Act and reserves the right to file additional documents
                as and when directed by the Hon’ble Court. The Petitioner also
                reserves the right to initiate appropriate civil and criminal
                proceedings against the Accused in competent courts.
                <br />
                <br />
                It is essential to acknowledge that it takes years for a person
                to build a career and earn respect in their professional
                community. The allegations levied against the Complainant strike
                at the very root of his professional credibility.
                <br />
                <br />
                The defamatory nature of these allegations is such that any
                rational individual would begin to question the Complainant’s
                moral and professional character, leading to irreparable harm to
                his workplace reputation. Every individual, regardless of their
                personal disputes or litigations, has a right to livelihood with
                dignity. The email made direct references to the Complainant’s
                personal life, which are irrelevant to his professional
                capabilities, and have been concocted deliberately to defame
                him.
                <br />
                <br />
                The email further portrayed the Complainant as being in default
                of the law, which is highly unjustified, as the Complainant is a
                peace-loving and law-abiding citizen who has never been involved
                in any legal misconduct. In another instance, the Accused in her
                email dated 21st April 2024, also tried to portray the
                Complainant as incapable of holding professional
                responsibilities, stating:
                <br />
                <br />
                “A person who can’t manage his own family’s image socially than
                how can a company thinks he will be able to handle their image
                in market.”
                <br />
                <br />
                She further referred to the Complainant using terms like “pain
                in the neck” and “cold fish”. These acts have turned the
                Complainant into a subject of ridicule and gossip among his
                colleagues and supervisors.
                <br />
                <br />
                The Complainant’s plight did not end there. On 21st April 2024,
                the Accused again sent an email to the Complainant, copying in
                all HR managers. This was again received at his home in Khanpur,
                Delhi, and demonstrated the Accused's intent to defame the
                Complainant at his workplace and among his friends and
                relatives.
                <br />
                <br />
                The relevant portion of the email reads:
                <br />
                <br />
                “I am going to show these things not to your office guys as well
                as your all relatives by appearing with police in person at
                their doorstep.”
                <br />
                <br />
                That the Accused has caused immense damage and has tarnished the
                reputation of the Complainant with certain ulterior motives
                calculated to defame and cause disrepute in the society and
                public at large by filing such complaints and making the
                aforesaid defamatory statements in a highly reckless manner. The
                imputations were false, defamatory in nature, and lacking in
                good faith. These imputations were made maliciously and with
                utter recklessness, where the Accused had knowledge or reason to
                believe that they were untrue, absolutely without foundation,
                and that the same would harm the reputation of the Complainant,
                thereby lowering his reputation among business colleagues,
                members of the public, and right-thinking members of society.
                <br />
                <br />
                The said imputations were made by the Accused without verifying
                their correctness, devoid of due care, attention, and inquiry,
                which she was duty-bound to undertake but wilfully failed to do.
                These imputations lacked honesty of purpose and were made solely
                to harm the reputation of the Complainant, constituting a
                conscious violation of the law. The Accused acted without any
                sense of responsibility, prudence, propriety, care, or caution.
                <br />
                <br />
                To say the least, the said imputations were totally
                irresponsible, actuated by ill-will, malice, improper motives,
                and for collateral considerations.
                <br />
                <br />
                It is submitted that following these acts by the Accused against
                the Complainant, by levelling false accusations, the Accused has
                caused severe injury to the Complainant’s reputation. The
                Accused deliberately levelled false allegations to tarnish the
                Complainant’s image in society. The Accused is also threatening
                to send various false emails to the Complainant's friends in an
                effort to defame him.
                <br />
                <br />
                The defamatory allegations are sufficient to lower the image of
                the Complainant in the eyes of society and the general public
                and have been deliberately submitted before this Hon’ble Court
                and then circulated among the common friends of the Complainant,
                enabling various persons to read these defamatory contents,
                which include false, fabricated, and defamatory allegations,
                with certain portions containing extremely defamatory language.
                <br />
                <br />
                Due to the above false allegations submitted by the Accused
                before the Court and communicated to the public at large, the
                Complainant has undergone severe embarrassment in society and
                the workplace. The allegations have stirred the Complainant’s
                friend circle. The Accused intentionally committed these acts to
                insult and cause reputational damage to the Complainant and his
                family.
                <br />
                <br />
                The Complainant respectfully submits that the allegations
                levelled by the Accused are false, mischievous, groundless,
                fictional, imaginary, fabricated, concocted, and defamatory per
                se. These allegations regarding the personal life and alleged
                unhealthy behaviour of the Complainant are utterly false,
                scurrilous, derogatory, disparaging, slanderous, and defamatory
                in nature, unsubstantiated by any cogent or irrefutable
                evidence.
                <br />
                <br />
                The Accused made these allegations simply to defame, derogate,
                and humiliate the Complainant and his family among her social
                circle and society at large, out of grudge, envy, jealousy, with
                dishonest, malicious, and mischievous intentions to cause
                wrongful loss and damage to his reputation and to tarnish the
                goodwill of the Complainant and his family both domestically and
                internationally.
                <br />
                <br />
                Due to these imputations and their wide communication and
                dissemination, the Complainant’s prestige, credit, and
                reputation were grossly undermined, jeopardized, and damaged,
                causing him to be regarded with hatred, contempt, ridicule,
                derision, dislike, disgrace, and disesteem among the members of
                society and the general public.
                <br />
                <br />
                That this is not the first time the Accused has tried to defame
                the Complainant before his employers; she has done the same act
                in the past also by sending false, frivolous, and malicious
                emails to the immediate boss of the Complainant along with other
                higher officials. In these mails, she alleged that the
                Complainant is a person of bad character, etc.
                <br />
                <br />
                That the emails dated 17.03.2024, 21.04.2024 and other mails
                sent by the Accused and other officials of the petitioner were
                received by the Accused at his home and, as the Complainant
                resides within the jurisdiction of this Hon'ble Court, the
                publication of defamatory material against a person gives rise
                to a cause of action only when it is made known to a third
                party. The place of the third party and the place where it is
                known to a third party gains importance. Thus, this Hon'ble
                Court has the jurisdiction to entertain the present complaint.
                <br />
                <br />
                That the Accused has thus committed the offence of defamation as
                defined under Section 499 read with Section 500 of the Indian
                Penal Code.
                <br />
                <br />
                That the Accused knowingly made imputation concerning the
                Complainant intending to harm the reputation of the Complainant,
                well knowing that such imputation would harm the reputation of
                the Complainant. As such, the Accused is liable to be prosecuted
                under Sections 499 and 500 of the Indian Penal Code.
                <br />
                <br />
                That even though the kind of damage that the actions and
                imputations as made by the Accused have done to the reputation
                and hard-earned goodwill of the Complainant cannot be
                compensated in terms of money, the Complainant seeks to reserve
                his right to pursue other appropriate legal remedies along with
                the filing of the present complaint.
                <br />
                <br />
                That in light of the aforementioned defamatory acts committed by
                the Accused, and the consequent irreparable harm caused to the
                Complainant’s reputation and mental well-being, the Complainant
                has been compelled to file the present criminal complaint under
                Section 356 of the Bharatiya Nyaya Sanhita, 2023, in accordance
                with the mandate of Section 222(1) of the Bharatiya Nagarik
                Suraksha Sanhita, 2023, before the Hon’ble Court of Ld. Chief
                Metropolitan Magistrate, Saket Courts, New Delhi, which has due
                jurisdiction in the matter. It is submitted that, as per the
                statutory requirement, the offence being punishable under
                Section 356 of the BNS can only be taken cognizance of upon a
                complaint made by a person aggrieved by such offence.
                Accordingly, the present complaint satisfies the threshold of
                statutory compliance
                <br />
                <br />
                The Complainant has filed a list of all relevant documents that
                are in his power and possession. The Complainant seeks liberty
                to file such other documents as may be found necessary at
                subsequent stages of proceedings.
              </Text>

              <Text fontSize="md">
                Have questions about the competition? Check out our{" "}
                <Link
                  href="https://www.lawvs.com/faq"
                  color="blue.500"
                  isExternal
                >
                  FAQ for Teams <ExternalLinkIcon mx="2px" />
                </Link>
              </Text>
            </Stack>
          </Box>
        </VStack>
      </Box>
      <Footer />
    </>
  );
};
